var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import PlaybackList from "./PlaybackList";
import PlaybackHistory from "./PlaybackHistory";
import { AUTOREPLAY_KEY, SHUFFLE_KEY, PlayerState, AddToHistory, HQ_KEY } from "./types";
import Player from "./Player";
import * as uuid from 'uuid';
import Popup from "../components/Popup";
import { usernameOrFullName } from "../util/user";
import { BPMSoundsGeneric } from "../generic";
import { PlayerCache } from "./PlayerCache";
var uuidv4 = uuid.v4;
/**
 * This class manages playback of various types of lists & tracks
 */
var PlaybackManager = /** @class */ (function () {
    function PlaybackManager() {
        // Properties
        this._playbackStateListeners = {};
        this._playbackConfigListeners = {};
        this._playbackContentManager = new PlaybackList();
        this._playbackConfig = {
            shuffle: false,
            autorepeat: false,
            hq: localStorage[HQ_KEY] == 'true'
        };
        this.playbackConfig = {
            shuffle: (localStorage[SHUFFLE_KEY] == 'true'),
            autorepeat: (localStorage[AUTOREPLAY_KEY] == 'true'),
            hq: this.playbackConfig.hq
        };
    }
    PlaybackManager.packageToPlayableSound = function (pack, demo) {
        return {
            file_url: demo == 1 ? pack.demo_file_url : pack.demo_file_url_2,
            wave: demo == 1 ? pack.demo_wave : pack.demo_wave_2,
            type: 'Demo',
            id: pack.id + ("-" + demo),
            name: pack.name,
            artist: pack.artist || '',
            artwork_url: pack.artwork_url,
            Label: pack.Label,
            sound_package_id: pack.id,
            __typename: pack.__typename
        };
    };
    PlaybackManager.contestToPlayableSound = function (contest) {
        return {
            file_url: contest.song_url,
            wave: contest.song_wave,
            type: 'Contest',
            id: contest.id,
            name: contest.song_title,
            artist: contest.song_artist,
            artwork_url: contest.artwork_url,
            __typename: 'Contest'
        };
    };
    PlaybackManager.contestSubmissionToPlayableSound = function (submission) {
        return {
            file_url: submission.song_url,
            wave: submission.song_wave,
            type: 'Contest',
            id: submission.id,
            name: submission.title,
            artist: usernameOrFullName(submission.user),
            artwork_url: submission.user.profile_image_thumbnail_url,
            __typename: 'ContestSubmission'
        };
    };
    PlaybackManager.isSoundEqualSoundPackage = function (pack, sound) {
        if (sound.id.startsWith(pack.id)) {
            if (sound.id == pack.id + "-1") {
                return 1;
            }
            else if (sound.id == pack.id + "-2") {
                return 2;
            }
        }
        return false;
    };
    PlaybackManager.isSoundEqualContest = function (contest, sound) {
        return sound.id == contest.id;
    };
    PlaybackManager.isSoundEqualContestSubmission = function (contest, sound) {
        return sound.id == contest.id;
    };
    PlaybackManager.isSound = function (sound) {
        return ('sound_package_id' in sound || 'album_id' in sound) && sound.type != 'Demo' && sound.type != 'Contest';
    };
    ;
    /**
     * This returns the shared instance to use as the global PlaybackManager
     */
    PlaybackManager.getInstance = function () {
        if (PlaybackManager.instance) {
            return PlaybackManager.instance;
        }
        PlaybackManager.instance = new PlaybackManager();
        return PlaybackManager.getInstance();
    };
    // Playback Configuration
    /**
     * This function starts playback of a track
     * @param trackData - The info about the track to play
     * @param resolveMedia - A function that resolves media urls if not provided in trackData
     * @param startPlayback - Defines if content should only be prepared but not played yet
     */
    PlaybackManager.prototype.startTrack = function (trackData, startPlayback, onDurationCallback) {
        var _a, _b;
        if (startPlayback === void 0) { startPlayback = true; }
        return __awaiter(this, void 0, void 0, function () {
            var track, data, mediaToPlay;
            return __generator(this, function (_c) {
                if (((_a = this.playbackState) === null || _a === void 0 ? void 0 : _a.state) === PlayerState.Playing) {
                    (_b = this._internalPlayer) === null || _b === void 0 ? void 0 : _b.setStreamedDuration();
                }
                if (trackData == undefined) {
                    return [2 /*return*/, false];
                }
                track = trackData.sound;
                if (track.file_url == undefined) {
                    Popup.creditLimit(false);
                    return [2 /*return*/, false];
                }
                if (!track) {
                    return [2 /*return*/, this.forward()];
                }
                data = Object.assign({}, trackData, { track: track });
                switch (trackData.playlist.historyMode()) {
                    case AddToHistory.ALL:
                    case AddToHistory.GLOBAL_ONLY:
                    default:
                        PlaybackHistory.getInstance().addTrack(data);
                        break;
                    case AddToHistory.LOCAL_ONLY:
                        break;
                }
                mediaToPlay = data.track;
                if (mediaToPlay) {
                    this.setPlaybackState({
                        media: {
                            playlist: data.playlist,
                            sound: mediaToPlay
                        },
                        state: startPlayback ? PlayerState.Loading : PlayerState.Paused
                    }, data, true);
                    try {
                        if (startPlayback) {
                            return [2 /*return*/, this.startPlayback(data, onDurationCallback)];
                        }
                    }
                    catch (error) {
                    }
                }
                return [2 /*return*/, false];
            });
        });
    };
    // Internal Playback State
    PlaybackManager.prototype.startPlayback = function (media, onDurationCallback) {
        var _this = this;
        var _a, _b, _c;
        var _d = PlaybackManager.getTrackUrl(media.sound), url = _d.url, original_duration = _d.duration;
        if (((_a = this.playbackState) === null || _a === void 0 ? void 0 : _a.state) == PlayerState.Paused && ((_b = this.playbackState.media) === null || _b === void 0 ? void 0 : _b.sound.id) == media.sound.id) {
            return (_c = this._internalPlayer) === null || _c === void 0 ? void 0 : _c.resume();
        }
        if (url) {
            var additional_Info = {};
            if (original_duration) {
                additional_Info.duration = parseFloat(original_duration);
            }
            this.setPlaybackState(Object.assign({}, this.playbackState, {
                media: Object.assign({}, media, __assign({}, additional_Info)),
            }), media);
            var play = function (url) { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    this._internalPlayer && this._internalPlayer.play({
                        url: url, totalDuration: original_duration ? parseFloat(original_duration) : undefined,
                        type: media.sound.type,
                        silence_info: media.sound.silence_info,
                        onError: function (type, data) { return __awaiter(_this, void 0, void 0, function () {
                            var available, error_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(type == 'FileNotFound')) return [3 /*break*/, 6];
                                        if (!this._cookieProvider) return [3 /*break*/, 5];
                                        return [4 /*yield*/, this._cookieProvider.isSet()];
                                    case 1:
                                        available = _a.sent();
                                        if (!!available) return [3 /*break*/, 5];
                                        this.setPlaybackState(Object.assign({}, this.playbackState, {
                                            state: PlayerState.Loading
                                        }), media);
                                        _a.label = 2;
                                    case 2:
                                        _a.trys.push([2, 4, , 5]);
                                        return [4 /*yield*/, this._cookieProvider.set()];
                                    case 3:
                                        _a.sent();
                                        this._cookieProvider.isSet();
                                        return [2 /*return*/, this.startPlayback(media)];
                                    case 4:
                                        error_1 = _a.sent();
                                        this.setPlaybackState(Object.assign({}, this.playbackState, {
                                            state: PlayerState.Error
                                        }), media);
                                        return [2 /*return*/, false];
                                    case 5:
                                        this.setPlaybackState(Object.assign({}, this.playbackState, {
                                            state: PlayerState.Error
                                        }), media);
                                        return [2 /*return*/, false];
                                    case 6:
                                        this.setPlaybackState(Object.assign({}, this.playbackState, {
                                            state: PlayerState.Error
                                        }), media);
                                        return [2 /*return*/, false];
                                }
                            });
                        }); },
                        onPlay: function (trackDuration) {
                            onDurationCallback && onDurationCallback(_this.playbackState.media, trackDuration);
                            if (!original_duration)
                                _this.setPlaybackState(Object.assign({}, _this.playbackState, {
                                    duration: trackDuration
                                }), media);
                        },
                        onProgress: function (progress, trackDuration) {
                            _this.setPlaybackState(Object.assign({}, _this.playbackState, {
                                progress: progress,
                                duration: original_duration || trackDuration
                            }), media);
                        },
                        onStateChange: function (state) {
                            _this.setPlaybackState(Object.assign({}, _this.playbackState, {
                                state: state
                            }), media);
                        },
                        onEnd: function (target) {
                            _this.setPlaybackState(Object.assign({}, _this.playbackState, {
                                state: PlayerState.None
                            }), media);
                        }
                    });
                    return [2 /*return*/];
                });
            }); };
            play(url);
            if (PlaybackManager.isSound(media.sound)) {
                BPMSoundsGeneric.get().onStream(media.sound);
            }
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * This function retrieves the appropriate content url for a track based on content type and the available quality
     * @param info
     */
    PlaybackManager.getTrackUrl = function (info, serviceWorkerRedirect) {
        if (serviceWorkerRedirect === void 0) { serviceWorkerRedirect = true; }
        if (Player.hlsSupported() && (info.type == 'Demo' || info.type == 'Contest' || info.__typename == 'Sound' || info.__typename == 'SoundVersion')) {
            return {
                url: serviceWorkerRedirect ? PlayerCache.redirectMediaUrl(info.file_url.hls) : info.file_url.hls,
                duration: info.duration,
                silence_info: info.silence_info
            };
        }
        return {
            url: serviceWorkerRedirect ? PlayerCache.redirectMediaUrl(info.file_url.mp3) : info.file_url.mp3,
            duration: info.duration,
            silence_info: info.silence_info
        };
    };
    // Playback Actions
    /**
     * This function pauses the currently playing track
     * @param cb - Called after pausing the track
     */
    PlaybackManager.prototype.pause = function (cb, reset) {
        var _this = this;
        this._internalPlayer && this._internalPlayer.pause(function () {
            var _a;
            if (reset) {
                (_a = _this._internalPlayer) === null || _a === void 0 ? void 0 : _a.setStreamedDuration();
                _this.seek(0);
            }
            cb && cb();
        });
    };
    /**
     * This function resumes or starts playback at the start of the currently active list depending on the current playback state
     */
    PlaybackManager.prototype.play = function () {
        if (this.playbackState && this.playbackState.media) {
            this.startPlayback(this.playbackState.media);
            return true;
        }
        else {
            return this.forward();
        }
    };
    /**
     * This function stops the player and resets the players state
     */
    PlaybackManager.prototype.stop = function () {
        this._internalPlayer && this._internalPlayer.stop();
        this.setPlaybackState({ state: PlayerState.None }, undefined, true);
    };
    /**
     * This function skips to the next song if the player is already playing or starts the next track if nothing is playing yet
     */
    PlaybackManager.prototype.forward = function () {
        var playingTrack = this.getTrack();
        if (playingTrack) {
            var nextTrack = this._playbackContentManager.getTrackAfter(playingTrack);
            if (nextTrack) {
                this.startTrack(nextTrack, true);
                return true;
            }
        }
        return false;
    };
    /**
     * This function rewinds the current song to the start if playback has occurred for more than 4 seconds or plays the previous song if playback has occurred for less than 4 seconds
     * @param forcePlay - If provided, the track is automatically started after rewinding from a stopped state
     */
    PlaybackManager.prototype.rewind = function (forcePlay) {
        if (forcePlay === void 0) { forcePlay = false; }
        if (this._playbackState && this._playbackState.progress && this._playbackState.progress > 4 || forcePlay) {
            this.seek(0);
            if (forcePlay) {
                this.play();
            }
            return true;
        }
        var playingTrack = this.getTrack();
        if (playingTrack) {
            var nextTrack = this._playbackContentManager.getTrackBefore(playingTrack);
            if (nextTrack) {
                var isPlayingRightNow = this.playbackState && this.playbackState.state !== PlayerState.Paused;
                this.startTrack(nextTrack, isPlayingRightNow);
                return true;
            }
        }
        return false;
    };
    /**
     * Seeks the track to the specified duration
     * @param to
     */
    PlaybackManager.prototype.seek = function (to) {
        if (!this.getDuration())
            return;
        if (this.getProgress() === to)
            return;
        this._internalPlayer && this._internalPlayer.seek(to);
        this.setPlaybackState(Object.assign({}, this.playbackState, {
            progress: to
        }), this.playbackState && this.playbackState.media, true);
    };
    PlaybackManager.prototype.setVolume = function (to) {
        this._internalPlayer && this._internalPlayer.setVolume(to);
    };
    // Getters
    PlaybackManager.prototype.getVolume = function () {
        var _a;
        return (_a = this._internalPlayer) === null || _a === void 0 ? void 0 : _a.getVolume();
    };
    /**
     * The current instance that manages internal playback state
     */
    PlaybackManager.prototype.getContentManager = function () {
        return this._playbackContentManager;
    };
    /**
     * The current state of playback
     */
    PlaybackManager.prototype.getPlayingState = function () {
        if (this.playbackState) {
            return this.playbackState.state;
        }
        return PlayerState.None;
    };
    /**
     * The currently active track information
     */
    PlaybackManager.prototype.getTrack = function () {
        var state = this.playbackState;
        return state ? state.media : undefined;
    };
    /**
     * Checks if the provided track from the provided list is currently playing
     * @param track
     * @param playlist
     */
    PlaybackManager.prototype.isPlayingTrack = function (track, playlist) {
        var playingTrack = this.getTrack();
        return playingTrack && playingTrack.sound.id === track.id && playingTrack.playlist.isEqual(playlist);
    };
    /**
     * Checks if the player is currently playing video
     */
    PlaybackManager.prototype.isPlayingVideo = function () {
        return false;
    };
    /**
     * Returns the current playback progress
     */
    PlaybackManager.prototype.getProgress = function () {
        return (this.playbackState ? this.playbackState.progress : 0) || 0;
    };
    /**
     * Returns the duration of the active track
     */
    PlaybackManager.prototype.getDuration = function () {
        return this.playbackState && this.playbackState.duration;
    };
    // Configuration
    /**
     * Sets the cookied provider to use when streaming songs
     */
    PlaybackManager.prototype.setCookieProvider = function (provider) {
        this._cookieProvider = provider;
    };
    Object.defineProperty(PlaybackManager.prototype, "playbackConfig", {
        /**
         * Returns the active playback configuration
         */
        get: function () {
            return this._playbackConfig;
        },
        /**
         * Sets the active playback configuration
         */
        set: function (newValue) {
            this._playbackConfig = newValue;
            this.callPlaybackConfigListeners(newValue);
        },
        enumerable: false,
        configurable: true
    });
    ;
    ;
    PlaybackManager.prototype.setPlaybackState = function (newValue, forMedia, force) {
        if (force === void 0) { force = false; }
        if (forMedia && newValue && this._playbackState && this._playbackState.media && this._playbackState.media.sound.id === forMedia.sound.id) {
            //Do not reset progress ist ths trackid dosent changed!
            if (newValue && newValue.progress == undefined && this._playbackState && this._playbackState.progress !== undefined) {
                newValue.progress = this._playbackState.progress;
            }
            var prevValue = this._playbackState;
            this._playbackState = newValue;
            this.callPlaybackStateListeners(newValue, newValue.state !== prevValue.state);
        }
        else if (forMedia == undefined && newValue == undefined) {
            this._playbackState = newValue;
            this.callPlaybackStateListeners(newValue, true);
        }
        else if (forMedia && newValue && !this._playbackState) {
            this._playbackState = newValue;
            this.callPlaybackStateListeners(newValue, true);
        }
        else if (force) {
            this._playbackState = newValue;
            this.callPlaybackStateListeners(newValue, true);
        }
    };
    ;
    Object.defineProperty(PlaybackManager.prototype, "playbackState", {
        /**
         * Returns the current playback state
         */
        get: function () {
            return this._playbackState;
        },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(PlaybackManager.prototype, "autorepeat", {
        /**
         * Returns the current autorepeate mode
         */
        get: function () {
            return this.playbackConfig.autorepeat;
        },
        /**
         * Sets the auto repeat mode and saves it to local storage
         */
        set: function (newValue) {
            this.playbackConfig.autorepeat = newValue;
            localStorage[AUTOREPLAY_KEY] = (newValue ? 'true' : 'false');
            // BPMEventHandler.getInstance().callOnEvent({ object: Objects.AUTO_REPEATE });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlaybackManager.prototype, "shuffle", {
        /**
         * Returns the current shuffle mode
         */
        get: function () {
            return this.playbackConfig.shuffle;
        },
        /**
        * Sets the shuffle mode and saves it to local storage
        */
        set: function (newValue) {
            this.playbackConfig.shuffle = newValue;
            localStorage[SHUFFLE_KEY] = (newValue ? 'true' : 'false');
            this._playbackContentManager.setPlaybackMode(this.shuffle ? 'shuffle' : 'serial');
            // BPMEventHandler.getInstance().callOnEvent({ object: Objects.SHUFFLE });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlaybackManager.prototype, "hq", {
        /**
         * Returns the current hq mode
         */
        get: function () {
            return this.playbackConfig.hq;
        },
        /**
        * Sets the hq mode and saves it to local storage
        */
        set: function (newValue) {
            var doRestart = this.playbackConfig.hq != newValue;
            this.playbackConfig.hq = newValue;
            if (doRestart) {
                this.play();
            }
            localStorage[HQ_KEY] = (newValue ? 'true' : 'false');
        },
        enumerable: false,
        configurable: true
    });
    // Listeners
    /**
     * Registers a listener for changes in the current playback configuration
     * @param listener
     */
    PlaybackManager.prototype.addPlaybackConfigListener = function (listener) {
        var id = uuidv4();
        this._playbackConfigListeners[id] = listener;
        return id;
    };
    /**
     * Removes a playback configuration listener
     * @param id
     */
    PlaybackManager.prototype.removePlaybackConfigListener = function (id) {
        delete this._playbackConfigListeners[id];
    };
    PlaybackManager.prototype.callPlaybackConfigListeners = function (config) {
        var _this = this;
        Object.keys(this._playbackConfigListeners).map(function (key) { return _this._playbackConfigListeners[key]; }).forEach(function (cb) {
            cb(config);
        });
    };
    /**
     * Registers a listener for changes in the current playback state
     * @param listener
     */
    PlaybackManager.prototype.addPlaybackStateListener = function (listener) {
        var id = uuidv4();
        this._playbackStateListeners[id] = listener;
        return id;
    };
    /**
     * Registers a listener for changes in the current playback progress
     * @param listener
     */
    PlaybackManager.prototype.addPlaybackProgressStateListener = function (listener) {
        var id = uuidv4() + '_progress';
        this._playbackStateListeners[id] = listener;
        return id;
    };
    /**
     * Removes a playback state / progress listener
     * @param listener
     */
    PlaybackManager.prototype.removePlaybackStateListener = function (id) {
        delete this._playbackStateListeners[id];
    };
    PlaybackManager.prototype.callPlaybackStateListeners = function (config, playbackStateChanged) {
        var _this = this;
        Object.keys(this._playbackStateListeners).map(function (key) { return [key, _this._playbackStateListeners[key]]; }).forEach(function (data) {
            var key = data[0], cb = data[1];
            if (playbackStateChanged || key.endsWith('_progress')) {
                cb(config);
            }
        });
    };
    PlaybackManager.prototype.getNavigator = function () {
        return this._navigator;
    };
    PlaybackManager.prototype.setNavigator = function (navigator) {
        this._navigator = navigator;
    };
    // List Utils
    /**
     * Replaces the current playback queue with a single list
     * @param list
     * @param mode
     */
    PlaybackManager.prototype.setList = function (list, mode) {
        this._playbackContentManager.replaceLists(list);
        this.shuffle = mode === 'shuffle';
    };
    Object.defineProperty(PlaybackManager.prototype, "isPlayerVisible", {
        get: function () {
            if (this._internalPlayer) {
                return false;
            }
            return this._internalPlayer.isVisible;
        },
        enumerable: false,
        configurable: true
    });
    return PlaybackManager;
}());
export default PlaybackManager;
//# sourceMappingURL=PlaybackManager.js.map